import React, { useState } from "react";
import Pdf from "../../../../../../Components/Icons/Pdf";
import Filter from "../../../../../../Components/Icons/Filter";
import CloseIcon from "../../../../../../Components/Icons/Close";
import {
  CancelButton,
  SubmitButton,
} from "../../../../../../Components/Utils/Buttons";
import { useFormik } from "formik";
import axiosInstance from "../../../../../../Services/axiosCommon";

import FormikSelectTwo, {
  FormikSelectTwoSmall,
} from "../../../../../../Components/Utils/Select";
import { NuDate, NuDateSmall } from "../../../../../../Components/Utils/Input";
import UseDropDown from "../../../../../../Components/Hooks/useDropDown";
import NuDateFormat from "../../../../../../Components/Utils/NuDate";
import Xls from "../../../../../../Components/Icons/Xls";
import NuAmount from "../../../../../../Components/Utils/NuAmount";
import NewReportTable from "../../../../../../Components/Others/NewReportTable";
import UseFetchReportData from "../../../../../../Components/Hooks/useFetchReportData";
import DropDownAddMetaData from "../../../../../../Components/Utils/selectAddMetaData";
import useFetchMataData from "../../../../../../Components/Hooks/useFetchMataData";
import { Link } from "react-router-dom";
import {
  DownloadPDF,
  DownloadXLXS,
} from "../../../../../../Components/Utils/Download";
import useFetchMDIndex from "../../../../../../Components/Hooks/useFetchMDIndex";

function InScheduleReport() {
  const [showFilter, setShowFilter] = useState(false);
  // const { data: RFQAssignee } = UseDropDown("/user/procurement/drop-down");
  const [filter, setFilter] = useState(false);

  const { value: status } = useFetchMDIndex(
    `/dropdown/dropdown-details/`,
    "Status_Schedule"
  );
  const headers = [
    {
      title: "Ref.",
      width: "10%",
      field: "Ref",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Client",
      width: "10%",
      field: "Client",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Contract",
      width: "10%",
      field: "Contract",
      textAlign: "left",
      rowAlign: "left",
    },

    {
      title: "Description",
      width: "10%",
      field: "Description",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Location",
      width: "10%",
      field: "Location",
      textAlign: "left",
      rowAlign: "left",
    },
    {
      title: "Date",
      width: "15%",
      field: "Date",
      textAlign: "left",
      rowAlign: "left",
      type: "date",
    },
    {
      title: "Status",
      width: "10%",
      field: "Status",
      textAlign: "left",
      rowAlign: "left",
    },
  ];

  const [filterProps, setFilterProps] = useState({
    status: "",
    dateFrom: "",
    dateTo: "",
    assigneeId: "",
  });

  const [params, setParams] = useState({
    status: "",
    dateFrom: "",
    dateTo: "",
    assigneeId: "",
  });

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterProps,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (value) => {
      await new Promise((resolve) => setTimeout(resolve, 300)); // give Formik time to set isSubmitting
      setParams({
        status: value.status,
        dateFrom: value.dateFrom,
        dateTo: value.dateTo,
        assigneeId: value.assigneeId,
      });
      setTimeout(() => {
        setFilter(true);
        // closeFilterDialog();
      }, 1000);
    },
  });
  const { data, getData, dataLoading, total, other } = UseFetchReportData(
    "/xlsx-report/filter-schedule-tasks",
    params
  );

  function closeFilterDialog() {
    setShowFilter(false);
    formik.resetForm();
    setFilter(false);
    setParams({
      status: "",
      dateFrom: "",
      dateTo: "",
      assigneeId: "",
    });
  }

  return (
    <>
      <div className="w-full h-full overflow-auto">
        <div className="flex gap-x-2 justify-between  w-full  py-2">
          <div className=" max-w-[270px] pr-7 ">
            <p className=" font-semibold text-xs 2xl:text-sm  ">
             Inspection Schedule Report : {data?.length}
            </p>
          </div>
          <div className=" flex-1 ">
            <form onSubmit={formik.handleSubmit}>
              <div className=" w-full grid grid-cols-4  gap-3">
                <NuDateSmall
                  label="From "
                  placeholder="dd/mm/yyyy"
                  formik={formik}
                  name="dateFrom"
                  width="w-full"
                />
                <NuDateSmall
                  label="To "
                  placeholder="dd/mm/yyyy"
                  formik={formik}
                  name="dateTo"
                  width="w-full"
                />
                <FormikSelectTwoSmall
                  label="Status"
                  Options={status}
                  formik={formik}
                  placeholder="Choose"
                  name="status"
                  width="w-full "
                />
                <div className=" w-full flex justify-end ">
                  <div className=" w-full flex items-end gap-2">
                    <SubmitButton name="Apply" isLoading={formik.isSubmitting} />
                    <CancelButton
                      label="Clear"
                      handleClick={closeFilterDialog}
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className=" w-[80px] flex justify-end items-end gap-4 ">
            <DownloadPDF
              url={`/xlsx-report/export-schedule-tasks-pdf`}
              fileName="Inspection Schedule Report"
              params={params}
            />
            <DownloadXLXS
              url={`/xlsx-report/export-schedule-tasks-excel`}
              fileName="Inspection Schedule Report"
              params={params}
            />
          </div>
        </div>
        {/* <div className="w-full   items-center gap-x-3">
          <div className="flex gap-x-2 justify-between items-center w-full">
            <p className=" font-semibold text-xs 2xl:text-sm  relative top-[-40px]">
              Inspection Schedule Report : {data?.length}
            </p>

            <form onSubmit={formik.handleSubmit}>
              <div className=" w-full grid grid-cols-3 gap-x-3">

              </div>
              <div className=" w-full flex justify-end mb-1.5">
                <div className=" w-full flex justify-end items-end gap-2">
                  <SubmitButton name="Apply" />
                  <CancelButton label="Clear" handleClick={closeFilterDialog} />
                </div>
              </div>
            </form>

            <div className=" flex gap-4 justify-end relative top-[-40px]">
              <DownloadPDF
                url={`/xlsx-report/export-clients-pdf`}
                fileName="Inspection Schedule Report"
                params={params}
              />
              <DownloadXLXS
                url={`/xlsx-report/export-schedule-tasks`}
                fileName="Inspection Schedule Report"
                params={params}
              />
            </div>
          </div>
        </div> */}
        <NewReportTable
          headers={headers}
          data={data}
          dataLoading={dataLoading}
        />
      </div>
    </>
  );
}

export default InScheduleReport;
